import getExtension from './extension';

const getExtensionSettings = (rootState, slug) => {
  const targetExtension = getExtension(rootState, slug) || {};

  return targetExtension.settings;
};

export default getExtensionSettings;
